module.exports = __webpack_public_path__ + "static/media/ribbon-app.223f4666.svg";